import * as React from "react";
const SvgBeneficiaryOutlined = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    // fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M5.6 14.55a14.8 14.8 0 0 1 3.15-1.163A13.8 13.8 0 0 1 12 13q.1 0 .175-.012a.4.4 0 0 1 .175.012.95.95 0 0 1 .638.475q.212.375.087.8t-.487.588A1.66 1.66 0 0 1 11.8 15a8 8 0 0 0-2.687.313Q7.775 15.7 6.5 16.35a.97.97 0 0 0-.5.85v.8h6.65q.5 0 .75.313.25.312.25.687t-.25.688-.75.312H6q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 18v-.8q0-.85.438-1.562.437-.713 1.162-1.088M12 12q-1.65 0-2.825-1.175T8 8t1.175-2.825T12 4t2.825 1.175T16 8t-1.175 2.825T12 12m0-2q.825 0 1.412-.588Q14 8.826 14 8q0-.824-.588-1.412A1.93 1.93 0 0 0 12 6q-.825 0-1.412.588A1.93 1.93 0 0 0 10 8q0 .825.588 1.412Q11.175 10 12 10m5.9 4.2q.5-.5.913-.85.412-.35 1.137-.35.925 0 1.488.637.562.638.562 1.438 0 .375-.15.75t-.45.675l-2.8 2.8q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-2.8-2.8a1.9 1.9 0 0 1-.463-.7q-.137-.375-.137-.75 0-.8.575-1.425T15.85 13q.7 0 1.1.325t.95.875"
    />
  </svg>
);
export default SvgBeneficiaryOutlined;
